import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination, TableWrapper, commonFilterMeta } from '../../Common/Table/types';
import Table from '../../Common/Table/Table';
import PaginationMobile from '../../../../../pages/Responsive/PaginationMobile';
import useGetNewProjectData from '../../../hooks/useGetNewProjectData';
import { RootState } from '../../../../../redux/root';
import { headers } from '../Documents/DocumentsTable';
import useOnCommonTableActivity from '../../../hooks/useOnCommonTableActivity';
import useStatusFilter from '../../../hooks/useStatusFilter';
import { getClientPermitActivities } from '../../../../../api/activities';
import {
  setPermitActivities,
  setPermitActivitiesLoading,
  setSelectedActivityPermit,
} from '../../../../../redux/slices/clientActivitiesSlice';

const ActivitiesTable = () => {
  useGetNewProjectData({ activities: true });
  const dispatch = useDispatch();
  const permitActivitiesList = useSelector(
    (s: RootState) => s.clientActivities.AllPermitsWithActivities,
  );
  const activitiesLoading = useSelector((s: RootState) => s.clientActivities.activitiesLoading);
  const { filteredRows, withStatusFilter } = useStatusFilter(permitActivitiesList);
  const { visibleItems } = useOnCommonTableActivity(filteredRows);

  const onActivitySelected = item => {
    loadActivitiesData(item, dispatch);
  };

  return (
    <TableWrapper>
      <Table
        collection={visibleItems}
        headers={withStatusFilter(headers)}
        filterMeta={commonFilterMeta}
        gridTemplateCols="1fr 1fr 138px 138px 90px"
        setSelectedItemInSlice={onActivitySelected}
        isLoading={activitiesLoading}
      />
      <Pagination>
        <PaginationMobile showEverywhere />
      </Pagination>
    </TableWrapper>
  );
};

export default ActivitiesTable;

// Fetches one permit's client-facing activities (Permitting / Proposal / Reviews).
// Uses the dedicated client endpoint rather than /project_activities/custom/: that
// one accepts only a single activity_type_name, scopes clients by franchise instead
// of by permit contacts, and ignores is_deleted -- which would let soft-deleted rows
// appear here and disagree with the counts on the list page.
export const loadActivitiesData = async (item, dispatch) => {
  dispatch(setPermitActivities([]));
  dispatch(setPermitActivitiesLoading(true));
  dispatch(setSelectedActivityPermit(item));
  try {
    const payload = await getClientPermitActivities(item.permitId);
    dispatch(setPermitActivities(payload.data as any));
  } catch (e) {
    dispatch(setPermitActivitiesLoading(false));
  }
};
